// calcularValorTotal.js
export default function calcularValorTotal(planoSelecionado, periodoSelecionado, cupomValido) {
    if (!planoSelecionado) return 0
  
    const meses = Number(periodoSelecionado)
    const valorMensal = Number(planoSelecionado.valor)
    let desconto = 0
  
    if (meses === 6) {
      desconto = planoSelecionado.desconto2 || 0
    } else if (meses === 12) {
      desconto = planoSelecionado.desconto3 || 0
    } else {
      desconto = planoSelecionado.desconto1 || 0
    }
  
    let valorTotal = valorMensal * meses * (1 - desconto / 100)
  
    if (cupomValido) {
      if (cupomValido.tipo === 'porcentagem') {
        valorTotal *= (1 - cupomValido.valor / 100)
      } else if (cupomValido.tipo === 'fixo') {
        valorTotal -= cupomValido.valor
      }
    }
  
    return Number(valorTotal.toFixed(2))
  }